import React from 'react';
import { GaugeContainer, GaugeFill } from './Gauge.styles';

const OneFourGauge: React.FC = () => {
  return (
    <GaugeContainer>
      <GaugeFill width="25%" color="#5ABD8D" />
    </GaugeContainer>
  );
};

export default OneFourGauge;
